'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MinusCircled = require('./MinusCircled');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MinusCircled).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/MinusCircled/index.js
// module id = 278
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16